import { isNumber, isString } from "es-toolkit";
//#region ../erd-editor-schema/dist/helper.js
function assign(valid, target, source) {
	return (key) => {
		if (!source) return;
		const value = source[key];
		if (valid(value)) target[key] = value;
	};
}
function entryId(key, entry) {
	const id = Reflect.get(entry, "id");
	return isString(id) && id !== "" ? id : key;
}
function validString(list) {
	return (value) => isString(value) && list.includes(value);
}
function validNumber(list) {
	return (value) => isNumber(value) && list.includes(value);
}
function propOr(target, propertyKey, defaultValue) {
	return Reflect.get(target, propertyKey) ?? defaultValue;
}
function restoreSequence(ids, seqIds) {
	const seq = new Set(seqIds);
	return ids.every((id) => seq.has(id)) ? seqIds : [...ids];
}
//#endregion
export { assign, entryId, propOr, restoreSequence, validNumber, validString };
